import React, { useContext } from "react";
import { PhotoManagerContext } from "./index";
import CreateDropdown from "./CreateActionDropdown";
import { useCreateAction } from "./useCreateAction";

const EventViewBreadcrumb: React.FC = () => {
  const context = useContext(PhotoManagerContext);

  const { handleGalleryClick, handleFolderClick } = useCreateAction();

  const eventsTileHeader = () => {
    const invitedCount = context?.eventsList?.length ?? 0;
    const headerText = context?.invitedEventsMode
      ? `${invitedCount} invited event${invitedCount === 1 ? "" : "s"}`
      : "All Media";
    return (
      <h2 className="ws-album-list-title">
        {headerText}
        {context?.isFilterEventsLoading ? (
          <span
            className="fa fa-spin fa-spinner"
            style={{ marginLeft: "10px" }}
          />
        ) : null}
      </h2>
    );
  };

  // Check if user has permission to create content at root level
  const canCreateAtRoot = context?.canCreateRootContent || false;

  return (
    <>
      {context?.isMobile ? <hr /> : null}
      <div className="ws-breadcrumbs ws-action-and-breadcrumbs ws-media-head">
        <div className="geo-flex">{eventsTileHeader()}</div>
        <div className="ws-events-tile-right">
          <div className="ws-album-list-actions">
            {context?.invitedEventsMode ? null : (
              <CreateDropdown
                onGalleryClick={handleGalleryClick}
                onFolderClick={handleFolderClick}
                canCreateEvents={canCreateAtRoot}
                canCreateFolders={canCreateAtRoot}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default EventViewBreadcrumb;
